import moment from "moment";

export default (results) => {
  let storingen = results.map((result) => {
    result = result.result || {};
    const results = result.results || [];
    return results.map(
      ({
        alert_id,
        header,
        description,
        start_time,
        end_time,
        routes,
        operator_specific_data,
      }) => ({
        alert_id,
        header,
        description,
        start_time,
        end_time,
        routes: routes.map((route) => ({
          route_id: route.route_id,
          route_short_name: route.route_short_name,
          route_long_name: route.route_long_name,
          agency_id: route.agency_id,
          route_text_color: route.route_text_color,
          route_color: route.route_color,
        })),
        stops: ((operator_specific_data || {}).data || {}).Stops || [],
      })
    );
  });

  storingen = storingen.flatten().sort((a, b) => {
    a = moment(a.start_time);
    b = moment(b.start_time);

    if (a > b) return -1;
    if (a < b) return 1;
    return 0;
  });

  return storingen;
};



// WEBPACK FOOTER //
// ./src/api/mapping/storingen.js